import SiteHeader from "../components/SiteHeader";
import SiteFooter from "../components/SiteFooter";
import { useSEO } from "../components/useSEO";
import "./Legal.css";

export default function Disclaimer() {
  useSEO(
    "Disclaimer | Modus",
    "Modus's tools support provider search, scoring, and verification as informational and analytical aids, not medical advice or a guarantee of outcomes."
  );

  return (
    <>
      <SiteHeader />

      <section className="legal-hero">
        <div className="wrap">
          <p className="legal-kicker">Legal</p>
          <h1>Disclaimer</h1>
          <p className="legal-updated">Last updated: September 25, 2026</p>
        </div>
      </section>

      <section className="legal-body">
        <div className="wrap">
          <div className="legal-content">
            <h2>General Information</h2>
            <p>The information provided by Modus ("the Company", "We", "Us" or "Our") on this website (the "Service") is for general informational purposes only. All information on the Service is provided in good faith, however We make no representation or warranty of any kind, express or implied, regarding the accuracy, adequacy, validity, reliability, availability or completeness of any information on the Service.</p>
            <p>Under no circumstance shall We have any liability to You for any loss or damage of any kind incurred as a result of the use of the Service or reliance on any information provided on the Service. Your use of the Service and Your reliance on any information on the Service is solely at Your own risk.</p>

            <h2>Not Medical or Professional Advice</h2>
            <p>Modus provides tools intended to assist with provider search, scoring, red-flag detection, call verification and related decision support. This content is informational and analytical in nature and is not intended to be, and should not be construed as, medical advice, a medical opinion, a diagnosis, or a guarantee of a provider's quality, credentials, or outcomes. Scores, ratings, and flags reflect an aggregation of available data at a point in time and may not reflect a provider's current status. Decisions about patient care, provider selection, or referrals remain the sole responsibility of the licensed professionals and organizations making them, and such decisions should always be verified independently and supported by appropriate clinical and professional judgment.</p>

            <h2>No Professional Relationship</h2>
            <p>Use of the Service does not create a professional, advisory, fiduciary, or other special relationship between You and the Company. Nothing on the Service should be relied upon as a substitute for independent verification, professional consultation, or Your own due diligence.</p>

            <h2>External Links Disclaimer</h2>
            <p>The Service may contain links to other websites or content belonging to or originating from third parties. Such external links are not investigated, monitored, or checked for accuracy, adequacy, validity, reliability, availability or completeness by Us. We do not warrant, endorse, guarantee, or assume responsibility for the accuracy or reliability of any information offered by third-party websites linked through the Service.</p>

            <h2>Errors and Omissions Disclaimer</h2>
            <p>While We have made every attempt to ensure the information on the Service is accurate and up to date, We are not responsible for any errors or omissions, or for the results obtained from the use of this information. Any reliance You place on such information is strictly at Your own risk.</p>

            <h2>No Guarantee of Availability</h2>
            <p>We do not guarantee that the Service will be uninterrupted, timely, secure, or error-free, or that defects will be corrected. The Service may be temporarily unavailable due to maintenance, technical issues, or circumstances beyond Our control.</p>

            <h2>Limitation of Liability</h2>
            <p>To the fullest extent permitted by applicable law, the Company disclaims all liability for any direct, indirect, incidental, consequential, special, or exemplary damages arising out of or in connection with Your use of, or inability to use, the Service or any content or information made available through it.</p>

            <h2>Consent</h2>
            <p>By using the Service, You hereby consent to this Disclaimer and agree to its terms.</p>

            <h2>Contact Us</h2>
            <p>If you have any questions about this Disclaimer, You can contact us:</p>
            <ul>
              <li>By email: <a href="mailto:info@modus.org">info@modus.org</a></li>
            </ul>
          </div>
        </div>
      </section>

      <SiteFooter />
    </>
  );
}
